import React, { useEffect, useState } from "react";
import Footer from "../Footer/Footer";
import BetModel from "../Models/BetModel/BetModel";
import RestrictedModel from "../Models/RestrictedModel/RestrictedModel";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import {
  onFetchSports,
  onGetCountriesLeagues,
  onGetCountriesList,
  getFixturesListByLeague,
  getFixturesListBySport,
  onUpdateMatchOdds,
  onUserBetSport,
  getAllFixtures,
} from "../../redux/homeAction";
import moment from "moment";
import Banner from "../Banner/Banner";
import Loader from "../loader/Loader";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const styles = `
  .suspended-market {
    position: relative;
  }
  
  .suspended-market::after {
    content: "MERCADO SUSPENDIDO";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(200, 200, 200, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 1.2em;
    color: #333;
    z-index: 1;
  }

  @keyframes highlightOdds {
    0% { background-color: rgba(255, 215, 0, 0.3); }
    100% { background-color: transparent; }
  }

  .odds-highlight {
    animation: highlightOdds 2.5s ease-out;
  }

  .odds-highlight td {
    background-color: transparent;
  }
`;

const GameBets = ({ echo }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Local states
  const [show, setShow] = useState(""); // Holds selected sport ID
  const [country, setCountry] = useState("");
  const [selectedLeagueId, setSelectedLeagueId] = useState(null);
  const [loader, setLoader] = useState(false);
  const [matchData, setMatchData] = useState({});
  const [teamId, setTeamId] = useState("");
  const [fixturesList, setFixturesList] = useState([]);
  const [amount, setAmount] = useState("");
  const [updatedOdds, setUpdatedOdds] = useState({});

  const classSend = "position-relative";

  // Redux selectors
  const getOnGetFetchSports = useSelector((state) => state.home.getOnGetFetchSports);
  const getOnGetCountriesList = useSelector((state) => state.home.getOnGetCountriesList);
  const onMatchList = useSelector((state) => state.home.getOnGetMatchList);
  const getOnGetCountriesLeagues = useSelector((state) => state.home.getOnGetCountriesLeagues);

  const userDeatils = JSON.parse(localStorage.getItem("userDetails"));
  const lang = localStorage.getItem("lang");
  const todayDate = new Date();

  // Fetch sports and country list on mount
  useEffect(() => {
    setLoader(true);
    dispatch(onFetchSports(setLoader));
    dispatch(onGetCountriesList());
    dispatch(getAllFixtures()); // Load all fixtures by default
  }, [dispatch]);

  // Whenever onMatchList changes, update local fixturesList
  useEffect(() => {
    setFixturesList(onMatchList || []);
  }, [onMatchList]);

  /**
   * Subscribe to odds updates for each fixture in onMatchList
   * (OddsUpdated event => .odds.updated), using a PUBLIC channel.
   */
  useEffect(() => {
    if (!onMatchList || !echo) return;

    onMatchList.forEach((fixture) => {
      echo
        .channel(`odds.fixture.${fixture.id}`)
        .listen(".odds.updated", (data) => {
          dispatch(onUpdateMatchOdds(data));
          setUpdatedOdds(prev => ({
            ...prev,
            [data.fixture_id]: {
              home: true,
              draw: true,
              away: true,
              timestamp: Date.now()
            }
          }));
          
          // Clear highlight after animation
          setTimeout(() => {
            setUpdatedOdds(prev => {
              const newState = { ...prev };
              delete newState[data.fixture_id];
              return newState;
            });
          }, 2500);
        });
    });

    return () => {
      onMatchList.forEach((fixture) => {
        echo.channel(`odds.fixture.${fixture.id}`).stopListening(".odds.updated");
      });
    };
  }, [onMatchList, echo, dispatch]);

  /**
   * Whenever a league is selected (selectedLeagueId is set),
   * subscribe to the "fixtures.updated" event from that league channel
   * via a PUBLIC channel.
   */
  useEffect(() => {
    if (!selectedLeagueId || !echo) return;

    const leagueChannel = echo.channel(`league.${selectedLeagueId}`);
    
    leagueChannel.listen(".fixtures.updated", (data) => {
      console.log("Event received:", data);

      const { fixture, event_type } = data;
      
      setFixturesList(currentFixtures => {
        switch (event_type) {
          case 'created':
            return [...currentFixtures, fixture];
            
          case 'updated':
            return currentFixtures.map(existingFixture => 
              existingFixture.id === fixture.id ? fixture : existingFixture
            );

          case 'deleted':
            return currentFixtures.filter(existingFixture => 
              existingFixture.id !== fixture.id
            );

          default:
            return currentFixtures;
        }
      });
    });

    return () => {
      leagueChannel.stopListening(".fixtures.updated");
    };
  }, [selectedLeagueId, echo]);

  useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.innerText = styles;
    document.head.appendChild(styleSheet);
    return () => styleSheet.remove();
  }, []);

  /**
   * Handlers for UI
   */
  const changeValueAndApi = (e) => {
    const regionId = e.target.value;
    setCountry(regionId);
    setSelectedLeagueId(null); // Reset league selection
    setFixturesList([]); // Clear fixtures when country changes
    dispatch(onGetCountriesLeagues(regionId));
  };

  const changeLeague = (e) => {
    const leagueId = e.target.value;
    setSelectedLeagueId(leagueId);
    dispatch(getFixturesListByLeague(leagueId));
  };

  const userBetsGame = (id) => {
    if (!teamId) {
      toast.error("Please select a team to bet");
    } else if (!amount) {
      toast.error("Please enter an amount");
    } else {
      const data = {
        user_id: userDeatils?.user_id,
        fixture_id: id,
        team_id: teamId,
        amount,
      };
      dispatch(onUserBetSport(data, setTeamId, setAmount));
    }
  };

  const openModelBYId = (id) => {
    const data = fixturesList?.find((item) => item.id === id);
    setMatchData(data || {});
  };

  return (
      <>
        <Navbar classSend={classSend} />
        <section id="Tabs_section" className="Bats_tab">
          <div className="container">
            <h1 className="h1_60">BETS</h1>
            {/* <div className="ad_section ad-top">
              <div className="row ad_content">
                <div className="col-md-12">
                  <img src="./images/ad2.png" className="img-fluid" alt="ad" />
                </div>
              </div>
            </div> */}
            <div className="Sports_tabs">
              {loader ? (
                  <div className="text-center">
                    <Loader />
                  </div>
              ) : (
                  <div className="tabs_nav">
                    <div className="row w-100 justify-content-center">
                      {getOnGetFetchSports?.map((data, i) => (
                          <div
                              key={i}
                              onClick={() => {
                                dispatch(getFixturesListBySport(data.id));
                                setShow(data.id);
                              }}
                              className={`col-md-4 sports_active_show mb-2 ${
                                  show === data.id ? "sports_active" : ""
                              }`}
                          >
                            <div>
                              <div className="sports_img sports_img1">
                                <img 
                                  src={data.image || "/images/sports-placeholder.jpg"} 
                                  className="img-fluid" 
                                  alt="sport"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = "/images/sports-placeholder.jpg";
                                  }}
                                />
                              </div>
                              <a>{data.sport_name}</a>
                            </div>
                          </div>
                      ))}
                    </div>
                  </div>
              )}
              <div className="bets_section">
                <div className="bets_content">
                  <div className="matches_history">
                    <div className="row dropdowns gy-3">
                      <div className="col-md-6 col-sm-6 col-lg-3">
                        <div className="selectCountry">
                          <select
                              className="form-select"
                              aria-label="Default select example"
                              onChange={changeValueAndApi}
                              value={country}
                          >
                            <option value="">Country</option>
                            {getOnGetCountriesList?.map((data, i) => (
                                <option value={data.id} key={i}>
                                  {data.name}
                                </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-6 col-lg-3">
                        <div className="selectLeague">
                          <select
                              className="form-select"
                              aria-label="Default select example"
                              onChange={changeLeague}
                              value={selectedLeagueId || ""}
                          >
                            <option value="">League</option>
                            {getOnGetCountriesLeagues?.map((data, i) => (
                                <option value={data.id} key={i}>
                                  {data.league_name}
                                </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="upcoming_matches_list d-flex justify-content-between">
                      <div className="col-md-auto">
                        <h1>
                          Upcoming <span className="color_yellow">Matches</span>
                        </h1>
                      </div>
                    </div>
                    <div className="upcoming_matches_table">
                      {fixturesList?.length === 0 ? (
                          <div>
                            <p
                                style={{
                                  color: "#ff6a0d",
                                  marginBottom: "18px",
                                  textAlign: "center",
                                  fontSize: 18,
                                  fontWeight: 600,
                                }}
                            >
                              Data Not Found
                            </p>
                          </div>
                      ) : (
                          <div className="table-responsive">
                            <table className="table">
                              <thead>
                              <tr>
                                <th scope="col"></th>
                                <th scope="col">Matches</th>
                                <th scope="col">League</th>
                                <th scope="col">{lang === "es" ? "Local" : "Home"}</th>
                                <th scope="col">{lang === "es" ? "Empate" : "Tie"}</th>
                                <th scope="col">{lang === "es" ? "Visitante" : "Away"}</th>
                                <th scope="col">Action</th>
                              </tr>
                              </thead>
                              <tbody>
                              {fixturesList?.map((data, i) => (
                                  <tr key={i} className={`${!data?.moneyline ? "suspended-market" : ""} ${updatedOdds[data.id] ? 'odds-highlight' : ''}`}>
                                    <td>
                                      <img
                                          src={data.sport_image || "/images/sports-placeholder.jpg"}
                                          className="set_height_match"
                                          alt="sport icon"
                                          onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = "/images/sports-placeholder.jpg";
                                          }}
                                      />
                                    </td>
                                    <td>
                                      <h5>{data.sport_name}</h5>
                                      <div className="d-flex align-items-center">
                                        <img
                                          src={data.team1_logo || "/images/team.png"}
                                          className="set_height_match"
                                          alt="team1"
                                          onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = "/images/team.png";
                                          }}
                                        />
                                        <span className="mx-2">{data.name}</span>
                                        <img
                                          src={data.team2_logo || "/images/team.png"}
                                          className="set_height_match"
                                          alt="team2"
                                          onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = "/images/team.png";
                                          }}
                                        />
                                      </div>
                                      <p>
                                        {moment().isBefore(moment(data.start_date)) ? (
                                          moment(data.start_date).fromNow()
                                        ) : (
                                          <>
                                            <img src="./images/live_icon.png" alt="live icon" />
                                            <span className="bold_text">LIVE</span>
                                          </>
                                        )}
                                      </p>
                                    </td>
                                    <td>{data.league_name}</td>
                                    <td>{data?.moneyline?.home}</td>
                                    <td>{data?.moneyline?.draw}</td>
                                    <td>{data?.moneyline?.away}</td>
                                    <td>
                                      {userDeatils ? (
                                          <>
                                            {moment(todayDate).format("YYYY-MM-DD hh:mm:ss") <
                                            data.start_date ? (
                                                <div
                                                    className="btn post_btn btnFill betbtn"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#betHere"
                                                    onClick={() => openModelBYId(data.id)}
                                                >
                                                  <div className="btnfilltext">
                                                    Bet Here Now
                                                  </div>
                                                </div>
                                            ) : (
                                                <div className="btn post_btn btnFill betbtn">
                                                  <div className="btnfilltext">Bet Closed</div>
                                                </div>
                                            )}
                                          </>
                                      ) : (
                                          <div
                                              className="btn post_btn btnFill betbtn"
                                              onClick={() => {
                                                toast.error("Please login first");
                                                navigate("/login");
                                              }}
                                          >
                                            <div className="btnfilltext">Bet Here Now</div>
                                          </div>
                                      )}
                                    </td>
                                  </tr>
                              ))}
                              </tbody>
                            </table>
                          </div>
                      )}
                    </div>
                  </div>
                </div>
                <Banner />
              </div>
            </div>
          </div>
        </section>
        <Footer />

        <BetModel
            userBetsGame={userBetsGame}
            matchData={matchData}
            setTeamId={setTeamId}
            teamId={teamId}
            setAmount={setAmount}
            amount={amount}
        />
        <RestrictedModel />
      </>
  );
};

export default GameBets;
